import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Col, Row} from 'antd';

import {getAppSettings} from 'app/reducers/commonData/selectors';

interface AnimatedCounterProps {
    value: number;
    duration?: number;
    suffix?: string;
}

// eslint-disable-next-line no-magic-numbers
const AnimatedCounter: React.FC<AnimatedCounterProps> = ({value, duration = 2000, suffix = ''}) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let animationFrame: number;
        let startTime: number | null = null;

        const animate = (timestamp: number): void => {
            if (startTime === null) {
                startTime = timestamp;
            }

            const progress = Math.min((timestamp - startTime) / duration, 1);

            // eslint-disable-next-line no-magic-numbers
            const easedProgress = 1 - Math.pow(1 - progress, 3);

            setCount(Math.round(easedProgress * value));

            if (progress < 1) {
                animationFrame = requestAnimationFrame(animate);
            }
        };

        animationFrame = requestAnimationFrame(animate);

        return () => {
            cancelAnimationFrame(animationFrame);
        };
    }, [value, duration]);

    return (
        <>
            {count.toLocaleString('uk-UA')}
            {suffix}
        </>
    );
};

const ProjectStatistics: React.FC = () => {
    const appSettings = useSelector(getAppSettings);

    if (!appSettings) {
        return null;
    }

    return (
        <Row className="target-wrap">
            <Col sm={8} md={4}>
                <div className="target">
                    <AnimatedCounter value={appSettings.projectYears} suffix=" років" />
                </div>
                <div className="target__description">здійснюємо мрії</div>
            </Col>

            <Col sm={8} md={4}>
                <div className="target">
                    <AnimatedCounter value={appSettings.allGiftsCount} />
                </div>
                <div className="target__description">бажань здійснено</div>
            </Col>

            <Col sm={8} md={4}>
                <div className="target">
                    <AnimatedCounter value={appSettings.giftsCount} />
                </div>
                <div className="target__description">дітей чекають</div>
            </Col>

            <Col sm={24} md={12} />
        </Row>
    );
};

export default ProjectStatistics;
